import React, {Fragment, useEffect, useState, useRef} from 'react';
import {Accordion, Section, Date_picker, Text, Select, TextEditor, Form, HtmlTooltip, MultipleSelect} from '../../../../components';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import EmailIcon from '@material-ui/icons/Email';
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import IconButton from '@material-ui/core/IconButton';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import {Field} from 'react-final-form';
import { FieldArray } from 'react-final-form-arrays';
import arrayMutators from 'final-form-arrays';
import Grid from '@material-ui/core/Grid';
import {connect} from 'react-redux';
import TuneIcon from '@material-ui/icons/Tune';
import Tooltip from '@material-ui/core/Tooltip';
import FactCheckIcon from '@material-ui/icons/PlaylistAddCheck';
import MenuIcon from '@material-ui/icons/Menu'


function Scorecards(props){
  let initial_uws_done=useRef(false);

  function onSubmit(params){
    if(props.match.params.id==undefined){props.createScorecard(params);}
    else{props.updateScorecard(props.match.params.id, params);}
  }


  let users=[]; if(props.workspace_data!=undefined){let us=props.workspace_data.user_workspaces; for(let key in us){if(us[key].superuser!=true){users.push({id:us[key].id, name:us[key].first_name+' '+us[key].last_name})}}}

  useEffect(()=>{
    console.log(props.match.params, props.match.params.id, props.match, 'MATCH');
    if(props.match.params.id!=undefined && (props.scorecards==undefined || props.scorecards[props.match.params.id]==undefined)){props.index_scorecards();}
  },[]);

  let initial_values={scorecard_trackers:[]};

  if(props.match.params.id!=undefined && props.scorecards!=undefined && props.scorecards[props.match.params.id]!=undefined){
    initial_values=props.scorecards[props.match.params.id];
  }
  if(props.workspace_data!=undefined){
    initial_values.user_workspace_ids=[];
    let us=props.workspace_data.user_workspaces;
    for(let key in us){let uw=us[key];
      if(props.match.params.id!=undefined && uw.scorecard_id==Number(props.match.params.id)){initial_values.user_workspace_ids.push(uw.id);}
    };
  }else{
    return null;
  }


  return(
    <Fragment>
    <Section title='New scorecard' icon={<CheckBoxIcon color='primary'/>} action={<Button variant='contained' onClick={()=>{props.history.push('/analytics/scorecards')}}>Exit</Button>}>
      <Form
        onSubmit={onSubmit}
        mutators={{
          ...arrayMutators
        }}
        initialValues={initial_values}
        handleClose={()=>{window.location.href='/analytics/scorecards';}}
      >
        {form_props => (
          <form onSubmit={form_props.handleSubmit}>
          <div style={{maxWidth:'400px', width:'100%'}}><Text required title='Name' name='name'/></div>
          <div style={{maxWidth:'400px', width:'100%'}}><Text required title='Description' name='description' rows={3}/></div>
          <div style={{marginLeft:'20px'}}><FormControlLabel control={<Field name='total_percentage'>{(f)=><Checkbox checked={f.input.value} onChange={f.input.onChange} name="total_percentage" />}</Field>} label="Display total percentage" /></div>
          <div style={{maxWidth:'400px', width:'100%', marginTop:'20px'}}><Field name='user_workspace_ids'>{(f)=>{
            return(<MultipleSelect title='Assign to team members' with_id select_data={users} value={f.input.value} onChange={f.input.onChange} />)}}</Field></div>
          <FieldArray name='scorecard_trackers'>
          {({ fields }) =>
            <Fragment>
            <Typography color='primary' style={{marginTop:'30px', marginBottom:'30px'}}><span><FactCheckIcon color='primary' style={{position:'absolute', left:'20px'}}/></span><span style={{marginLeft:'40px'}}>Events</span>{(fields.length==6)?null:<AddIcon color='secondary' style={{position:'absolute', right:'20px', cursor:'pointer'}} onClick={()=>{fields.push({}, undefined);}}/>}</Typography>
            {fields.map((name, index) => {
              return(
              <Fragment>
                <Grid container>
                  <Grid item xs={4} style={{position:'relative'}}><div style={{position:'absolute', top:'5px', width:'100%'}}><Select title='Type' type name={`${name}.type`} select_data={[{id:'PHONE_CALLS_OUTGOING', name:'Phone calls connected'}, {id:'PHONE_CALL_ATTEMPTS', name:'Phone call attempts'}, {id:'EMAILS_SENT', name:'Emails sent'}, {id:'TASKS_COMPLETED', name:'Tasks completed'}, {id:'MEETINGS_BOOKED', name:'Meetings booked'}, {id:'NEW_PROSPECTS', name:'New prospects'}, {id:'DEALS_OPENED', name:'New deals opened'}, {id:'OPPORTUNITIES_OPENED', name:'New opportunities opened'}]} style={{marginLeft:'20px', width:'calc(100% - 40px)'}}/></div></Grid>
                  <Grid item xs={4} style={{paddingBottom:'10px'}}><Text title='Daily target' type='number' name={`${name}.target`}/></Grid>
                  <Grid item xs={3}/>
                  <Grid item xs={1} style={{position:'relative', position:'relative'}}><DeleteIcon color='secondary' style={{position:'absolute', right:'0px', top:'10px', cursor:'pointer'}} onClick={(e)=>{fields.remove(index); e.stopPropagation()}}/></Grid>
                </Grid>
              <hr style={{width:'100%'}}/>
              </Fragment>
            )
            })}
            <div style={{marginTop:'30px', width:'100%', position:'relative', display:'flex', justifyContent:'center', alignItems:'center'}}><Button color='primary' variant='contained' onClick={()=>{form_props.form.submit();}}>Save</Button></div>
            </Fragment>
          }
          </FieldArray>
          </form>
        )}
      </Form>
    </Section>
    <div style={{height:'30px'}}/>
    </Fragment>
  );
}



export default connect(ss, dd)(Scorecards);


function ss(state){
  return{
    scorecards:state.analytics.scorecards
  }
}

function dd(dispatch){
  return{
    index_scorecards:()=>{dispatch({type:'REQUEST_INDEX_SCORECARDS'})},
    getScorecard:(id)=>{dispatch({type:'REQUEST_GET_SCORECARD', id:id})},
    createScorecard:(data)=>{dispatch({type:'REQUEST_CREATE_SCORECARD', payload:data})},
    updateScorecard:(id, data)=>{dispatch({type:'REQUEST_UPDATE_SCORECARD', id:id, payload:data})},
  }
}
